(function (window, document, $) {
    $(document).ready(function () {

        //Make element sticky
        if( $('[data-wp-sticky]').length ) {
            var sticky = new Waypoint.Sticky({
                element: $('[data-wp-sticky]'),
                wrapper: '<div class="cf-sticky-wrapper" />',
            })
        }

        //Make mobile header element sticky
        if( $('[data-wp-sticky-header-mob]').length ) {
            var sticky = new Waypoint.Sticky({
                element: $('[data-wp-sticky-header-mob]'),
                wrapper: '<div class="cf-sticky-wrapper-header-mob" />',
                offset: '50%'
            })
        }
    });

}(window, document, jQuery));